import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

const RoleAssignment = ({
    currentPlayer,
    roles,
    gameMode,
    selectedItem,
    roleRevealed,
    setRoleRevealed,
    onNextPlayer,
    numPlayers,
    t
}) => {
    return (
        <div className="border-t border-spy-border pt-6 text-center">
            <div>
                <p className="mb-3 text-[10.5px] font-semibold uppercase tracking-[0.22em] text-spy-primary">
                    Secret Role
                </p>
                <h2 className="mb-6 font-display text-[32px] font-medium leading-tight text-spy-text">
                    {t.passToPlayer} {currentPlayer + 1}
                </h2>

                {!roleRevealed ? (
                    <button
                        onClick={() => setRoleRevealed(true)}
                        className="flex min-h-[72px] w-full items-center justify-center space-x-2 rounded-spy bg-spy-text px-8 py-5 text-[15px] font-semibold text-spy-bg hover:opacity-90"
                    >
                        <Eye className="w-6 h-6" />
                        <span>{t.tapToReveal}</span>
                    </button>
                ) : (
                    <div className="space-y-6">
                        <button
                            onClick={() => setRoleRevealed(false)}
                            className="mx-auto mb-4 flex items-center justify-center space-x-2 text-sm font-semibold text-spy-muted hover:text-spy-primary"
                        >
                            <EyeOff className="w-4 h-4" />
                            <span>{t.hideRole}</span>
                        </button>

                        {roles[currentPlayer]?.isSpy ? (
                            <div className="border-y border-spy-border py-8">
                                <p className="mb-2 text-[10px] font-semibold uppercase tracking-[0.22em] text-spy-danger">
                                    Classified
                                </p>
                                <h3 className="font-display text-[31px] font-semibold text-spy-danger">
                                    {t.youAreTheSpy}
                                </h3>
                            </div>
                        ) : (
                            <div className="border-y border-spy-border py-8">
                                <h3 className="mb-2 text-[10px] font-semibold uppercase tracking-[0.22em] text-spy-primary">
                                    {gameMode === 'location' ? t.location : t.person}:
                                </h3>
                                <p className="mb-4 font-display text-[31px] font-semibold leading-tight text-spy-text">
                                    {selectedItem}
                                </p>
                                {gameMode === 'location' && roles[currentPlayer]?.role && (
                                    <>
                                        <h4 className="mb-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-spy-muted">
                                            {t.role}:
                                        </h4>
                                        <p className="font-display text-[19px] font-medium text-spy-soft">
                                            {roles[currentPlayer].role}
                                        </p>
                                    </>
                                )}
                            </div>
                        )}

                        <button
                            onClick={onNextPlayer}
                            className="min-h-[52px] w-full rounded-spy bg-spy-text px-6 py-4 text-[15px] font-semibold text-spy-bg hover:opacity-90"
                        >
                            {currentPlayer < numPlayers - 1 ? t.nextPlayer : t.finishSetup}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RoleAssignment;
